import { ARRAY_ERROR } from 'final-form';

type FinalFormArrayError = unknown[] & { [ARRAY_ERROR]?: string };

/**
 * Текст ошибки уровня массива (ARRAY_ERROR) или строковой ошибки поля-массива.
 * Для вложенных FieldArray нельзя возвращать строку из валидатора, если в массиве есть элементы —
 * только getArrayError / ARRAY_ERROR.
 */
export const getFieldArrayErrorMessage = (error: unknown): string | undefined => {
  if (!error) {
    return undefined;
  }

  if (typeof error === 'string') {
    return error;
  }

  if (Array.isArray(error)) {
    const arrayError = error as FinalFormArrayError;

    if (typeof arrayError[ARRAY_ERROR] === 'string') {
      return arrayError[ARRAY_ERROR];
    }
  }

  return undefined;
};

export const hasFieldArrayItemErrors = (error: unknown): boolean => {
  return (
    Array.isArray(error) &&
    !getFieldArrayErrorMessage(error) &&
    error.some(item => item && typeof item === 'object' && 'id' in item && !!(item as { id?: string }).id)
  );
};
